// extracted by mini-css-extract-plugin
export var hidden = "_sn-0";